// extracted by mini-css-extract-plugin
export var formContainer = "_gf-0";
export var message = "_gf-1";